import { Base, Component } from '@/vue-property-decorator'
import { RouteName } from '@/router/config'
import { TabKey } from '@/layouts/components/tabBar/types'
import { VipStatus } from '@/api/vip/type'
import { useMainStore } from '@/store/index'
import { useTabBarStore } from '@/layouts/components/tabBar/store'
import Skin from '@/controller/Skin'
import style from './style.module.scss'
const vipImg = '/lobby_asset/common/common/profile/img_vip.png'
@Component<VipBadge>({
  name: 'VipBadge'
})
export default class VipBadge extends Base<unknown> {
  render() {
    const { userInfos } = useMainStore()
    const { isHK } = Skin.currentTheme()
    const iconColor = userInfos?.vip_icon_back_color_value
    const { updateTabItem } = useTabBarStore()

    return (
      <fragment>
        {userInfos?.vip_status == VipStatus.OPEN && (
          <div
            class={[
              style.vip,
              isHK ? style.hkVip : '',
              'vip-badge',
              userInfos?.vip_level >= 10 ? style.maxVip : ''
            ]}
            style={{
              background: `#${iconColor}`
            }}
            onClick={() => {
              this.$router.push({
                name: RouteName.VIP
              })
              //5159定制 点击vip图标 footet tabbar切换到优惠
              if (Skin.currentTheme().is5159) {
                updateTabItem(TabKey.EVENT)
              }
            }}
          >
            <my-img src={vipImg} useSkeleton class={[style.img, 'vip-img']} />

            {/* <icon-sprite
              class={[style.vipSprite, 'vipSprite']}
              sprite={createSvgSprite('comm_img_vip1')}
            /> */}
            <span data-text={userInfos?.vip_level}>{userInfos?.vip_level}</span>
          </div>
        )}
      </fragment>
    )
  }
}
